/**
 * Pre-fills the protein and electrolytes calculators for a logged-in shopper, from the JSON that
 * snippets/calculadora-customer-data.liquid renders (nothing is rendered for a guest, so this is
 * a no-op for them).
 *
 * Both calculators use the same element ids for the fields they share, so one pass covers both;
 * an id a page doesn't have is skipped. Deliberately left for the shopper every time:
 *  - the terms checkbox — consent is asked on each submission, never carried over;
 *  - the músculo/grasa choice — it only applies to some BMIs, and is asked in context.
 * A field that already holds a value (browser autofill, back/forward restore) is not overwritten.
 *
 * Must load after the inline scripts that set up intl-tel-input: its DOMContentLoaded listener
 * has to run first so the phone can go through the instance.
 */
(function () {
  var ACTIVITY = { 'Muy activo': 0, 'Activo': 1, 'Poco activo': 2 };

  function read() {
    var el = document.getElementById('calculadora-customer-data');
    if (!el) {
      return null;
    }

    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function blank(value) {
    return value == null || String(value).trim() === '';
  }

  function normalize(text) {
    return String(text).replace(/\s+/g, ' ').trim();
  }

  function fill(id, value) {
    var el = document.getElementById(id);
    if (!el || blank(value) || el.value !== '') {
      return;
    }

    if (el.tagName !== 'SELECT') {
      el.value = value;
      return;
    }

    // A select only takes one of its own options — a stored answer the merchant has since
    // removed from the list is dropped rather than leaving the select in an invalid state.
    for (var i = 0; i < el.options.length; i++) {
      if (el.options[i].value !== '' && normalize(el.options[i].value) === normalize(value)) {
        el.value = el.options[i].value;
        return;
      }
    }
  }

  function check(id, value) {
    var el = document.getElementById(id);
    if (el && value === 'Si') {
      el.checked = true;
    }
  }

  /** Whole numbers only: both calculators strip anything but digits from these inputs. */
  function whole(value) {
    var n = parseFloat(value);
    return isNaN(n) ? null : String(Math.round(n));
  }

  /** Stored in metres ("1.75"), asked in centimetres. Anything already cm-sized is kept as is. */
  function centimetres(value) {
    var n = parseFloat(value);
    if (isNaN(n)) {
      return null;
    }

    return String(Math.round(n < 3 ? n * 100 : n));
  }

  function fillPhone(phone) {
    var input = document.getElementById('phonemodal');
    if (!input || blank(phone) || input.value !== '') {
      return;
    }

    // The stored number is E.164 ("+573001234567"). setNumber() picks the country from it and,
    // with separateDialCode, leaves only the national part in the input — which is what the
    // submit handlers expect next to `.iti__selected-dial-code`. Without the instance there's no
    // safe way to split the two, so the field is left for the shopper.
    var iti = window.intlTelInputGlobals && window.intlTelInputGlobals.getInstance(input);
    if (iti) {
      iti.setNumber(phone);
    }
  }

  function fillActivity(activity) {
    if (!(activity in ACTIVITY) || typeof window.changeTab !== 'function') {
      return;
    }

    if (document.querySelector('.actividad-option-img.active, .customjey__actividad-option-img.active')) {
      return;
    }

    // Each calculator's own changeTab() — it also sets the electrolytes calculator's `actividad`.
    window.changeTab(ACTIVITY[activity]);
  }

  function fillAnswer(data) {
    // The protein calculator stores which question was asked; if the merchant has changed it
    // since, the old answer belongs to a different question.
    var label = document.getElementById('preguntaadicionallabel');
    if (!blank(data.question) && label && normalize(label.textContent) !== normalize(data.question)) {
      return;
    }

    fill('preguntaAdicional', data.answer);
  }

  function apply() {
    var data = read();
    if (!data) {
      return;
    }

    fill('namemodal', data.firstName);
    fill('lastnamemodal', data.lastName);
    fill('emailmodal', data.email);
    fillPhone(data.phone);
    fillAnswer(data);

    fill('inputAge', whole(data.age));
    fill('inputWeightK', whole(data.weight));
    fill('inputHeightCm', centimetres(data.height));
    fill('selectGender', data.gender);
    fill('selectClimate', data.climate);
    check('ketoCheck', data.keto);
    check('diurCheck', data.diuretics);
    fillActivity(data.activity);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply);
  } else {
    apply();
  }
})();
